<template>
  <Navbar></Navbar>
  <div class="about-page">
    <div class="about-kv about-kv2">
      <div class="swiper-container kv-container" ref="swiperRefs">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="img-box">
              <img class="pc-pad" data-src="/assets/about/kv2.jpg" alt="">
              <img class="mb-only" data-src="/assets/about/kv-m.jpg" alt=""></img>
            </div>
            <div class="text-box ">
              <div class="title">
                FINEST Automotive Technology Group Co., Ltd.
              </div>
              <div class="text">
                An auto parts enterprise with core technologies of power system from traditional power to hybrid power
                and then to pure electric power (including inverters) and automotive intelligent integrated system.
                FINEST has a complete software and hardware industry chain.<br />
                Provide customers with efficient, energy-saving and environmentally friendly automotive power system and
                Intelligent driving solutions.
              </div>
            </div>
          </div>
        </div>
        <div class="kv_pagination swiper-pagination"></div>
      </div>
    </div>

    <div class="img-box about-culture">
      <img class="pc-pad" data-src="/assets/about/culture.jpg" alt="">
      <img class="mb-only" data-src="/assets/about/culture-m.jpg" alt="">
      <div class="culture-list">
        <div class="culture-item">
          <div class="culture-item-t1">
            Mission
          </div>
          <div class="culture-item-t2">
            Committed to building a low-carbon, environmentally friendly and sustainable technology-oriented
            organization, and creating a smart and wonderful driving experience for customers.
          </div>
        </div>

        <div class="culture-item">
          <div class="culture-item-t1">
            Vision
          </div>
          <div class="culture-item-t2">
            To become a global supplier of intelligent power systems & electronics solutions.
          </div>
        </div>

        <div class="culture-item">
          <div class="culture-item-t1">
            Value
          </div>
          <div class="culture-item-t2">
            Sincerity · Simplicity · Agility · Transparency
          </div>
        </div>

      </div>
    </div>

    <div class="img-box">
      <img class="pc-pad" data-src="/assets/about/mind-en.jpg" alt="">
      <img class="mb-only" data-src="/assets/about/mind-en-m.jpg" alt="">
    </div>
    <div class="about-map-box">
      <div class="img-box img-box-height" v-if="mapHoverBoxs2 == 1">
        <img class="pc-pad" src="/assets/about/map_en.jpg" alt="">
        <img class="mb-only" src="/assets/about/map1-en-m.jpg" alt="">

      </div>

      <div class="img-box img-box-height" v-if="mapHoverBoxs2 == 2">
        <img class="pc-pad" src="/assets/about/map_en.jpg" alt="">
        <img class="mb-only" src="/assets/about/map2-en-m.jpg" alt="">
      </div>
      <div class="about-map-layout about-map-item">
        <div class="about-map-text">
          <div class="about-map-title">
            Global Footprint
          </div>
          <div class="about-map-btn-list">
            <div class="about-map-btn" :class="mapHoverBoxs2 == 1 ? 'active' : ''" @click=" mapHoverBoxs2 = 1">
              R&D Centers
            </div>
            <div class="about-map-btn" :class="mapHoverBoxs2 == 2 ? 'active' : ''" @click=" mapHoverBoxs2 = 2">
              Production Factories
            </div>
          </div>
        </div>

        <!-- 7个 -->

        <div class="map-hover-box map-hover-box1 map-hover-box-right-top" v-if="mapHoverBoxs2 == 1">
          <div class="map-hover-text">
            <div class="map-hover-name">
              R&D in Baoding
            </div>
            <div class="map-hover-desc">
              Product: Engine、Transmission、E-drive.
            </div>
          </div>
          <div class="img-box">
            <img data-src="/assets/about/lt.png" alt="">
          </div>

        </div>

        <div class="map-hover-box map-hover-box2 map-hover-box-left-top" v-if="mapHoverBoxs2 == 1">
          <div class="map-hover-text">
            <div class="map-hover-name">
              R&D in Nanjing
            </div>
            <div class="map-hover-desc">
              Product: Cockpit software.
            </div>
          </div>

          <div class="img-box">
            <img data-src="/assets/about/rt.png" alt="">
          </div>

        </div>

        <div class="map-hover-box map-hover-box3" v-if="mapHoverBoxs2 == 1">
          <div class="map-hover-text">
            <div class="map-hover-name">
              R&D in Shanghai
            </div>
            <div class="map-hover-desc">
              Product: Engine、Transmission、Digital Cockpit、<br />Display、Body Control、Intelligent Connectivity.
            </div>
          </div>
          <div class="img-box">
            <img data-src="/assets/about/r.png" alt="">
          </div>

        </div>

        <div class="map-hover-box map-hover-box4 map-hover-box-left-top" v-if="mapHoverBoxs2 == 1">
          <div class="map-hover-text">
            <div class="map-hover-name">
              R&D in Suzhou
            </div>
            <div class="map-hover-desc">
              Product: Audio System、Radar.
            </div>
          </div>
          <div class="img-box">
            <img data-src="/assets/about/rt.png" alt="">
          </div>

        </div>

        <div class="map-hover-box map-hover-box5 map-hover-box-left" v-if="mapHoverBoxs2 == 1">
          <div class="map-hover-text">
            <div class="map-hover-name">
              R&D in Wuhan
            </div>
            <div class="map-hover-desc">
              Product: Cockpit software.
            </div>
          </div>
          <div class="img-box">
            <img data-src="/assets/about/l.png" alt="">
          </div>

        </div>
        <div class="map-hover-box map-hover-box6 map-hover-box-left" v-if="mapHoverBoxs2 == 1">
          <div class="map-hover-text">
            <div class="map-hover-name">
              R&D in Chengdu
            </div>
            <div class="map-hover-desc">
              Product: Cockpit software.
            </div>
          </div>
          <div class="img-box">
            <img data-src="/assets/about/l.png" alt="">
          </div>

        </div>
        <div class="map-hover-box map-hover-box7 map-hover-box-left" v-if="mapHoverBoxs2 == 1">
          <div class="map-hover-text">
            <div class="map-hover-name">
              R&D in Dongguan
            </div>
            <div class="map-hover-desc">
              Product: Transmission、E-drive.
            </div>
          </div>
          <div class="img-box">
            <img data-src="/assets/about/l.png" alt="">
          </div>
        </div>

        <!-- 14个 -->
        <div class="map-hover-box map-hover-box8 map-hover-box-right-top" v-if="mapHoverBoxs2 == 2">
          <div class="map-hover-text">
            <div class="map-hover-name">
              Baoding、Xushui、Dingxing
            </div>
            <div class="map-hover-desc">
              Product: Engine、Transmission
            </div>
          </div>
          <div class="img-box">
            <img src="/assets/about/lt.png" alt="">
          </div>
        </div>

        <div class="map-hover-box map-hover-box9 map-hover-box-left-top" v-if="mapHoverBoxs2 == 2">
          <div class="map-hover-text">
            <div class="map-hover-name">
              Zhangjiagang
            </div>
            <div class="map-hover-desc">
              Product: Digital Cockpit、Display、Intelligent Body <br> Control、Intelligent Connectivity、Audio System.
            </div>
          </div>
          <div class="img-box">
            <img src="/assets/about/rt.png" alt="">
          </div>
        </div>

        <div class="map-hover-box map-hover-box10 map-hover-box-left-top" v-if="mapHoverBoxs2 == 2">
          <div class="map-hover-text">
            <div class="map-hover-name">
              Tianjin
            </div>
            <div class="map-hover-desc">
              Product: Engine.
            </div>
          </div>
          <div class="img-box">
            <img src="/assets/about/rt.png" alt="">
          </div>
        </div>

        <div class="map-hover-box map-hover-box11" v-if="mapHoverBoxs2 == 2">
          <div class="map-hover-text">
            <div class="map-hover-name">
              Changshu
            </div>
            <div class="map-hover-desc">
              Product: Audio System、Body Control、<br />Intelligent Connectivity、Display.
            </div>
          </div>
          <div class="img-box">
            <img src="/assets/about/r.png" alt="">
          </div>
        </div>

        <div class="map-hover-box map-hover-box12 map-hover-box-right-top" v-if="mapHoverBoxs2 == 2">
          <div class="map-hover-text">
            <div class="map-hover-name">
              Yangzhong
            </div>
            <div class="map-hover-desc">
              Product: Engine、Transmission、E-drive.
            </div>
          </div>
          <div class="img-box">
            <img src="/assets/about/lt.png" alt="">
          </div>
        </div>
        <div class="map-hover-box map-hover-box20 map-hover-box-right-top" v-if="mapHoverBoxs2 == 2">
          <div class="map-hover-text">
            <div class="map-hover-name">
              HuBei
            </div>
            <div class="map-hover-desc">
              Product: Engine
            </div>
          </div>
          <div class="img-box">
            <img src="/assets/about/lt.png" alt="">
          </div>
        </div>

        <div class="map-hover-box map-hover-box13" v-if="mapHoverBoxs2 == 2">
          <div class="map-hover-text">
            <div class="map-hover-name">
              Wuxi
            </div>
            <div class="map-hover-desc">
              Product: Power Semiconductor(IGBT,SiC).
            </div>
          </div>
          <div class="img-box">
            <img src="/assets/about/r.png" alt="">
          </div>
        </div>

        <div class="map-hover-box map-hover-box14" v-if="mapHoverBoxs2 == 2">
          <div class="map-hover-text">
            <div class="map-hover-name">

            </div>
            <div class="map-hover-desc">

            </div>
          </div>
        </div>

        <div class="map-hover-box map-hover-box15 map-hover-box-right-top" v-if="mapHoverBoxs2 == 2">
          <div class="map-hover-text">
            <div class="map-hover-name">
              Chongqing
            </div>
            <div class="map-hover-desc">
              Product: Engine、Transmission.
            </div>
          </div>
          <div class="img-box">
            <img src="/assets/about/lt.png" alt="">
          </div>
        </div>

        <div class="map-hover-box map-hover-box16" v-if="mapHoverBoxs2 == 2">
          <div class="map-hover-text">
            <div class="map-hover-name">
              Jiangxi
            </div>
            <div class="map-hover-desc">
              Product: Engine.
            </div>
          </div>
          <div class="img-box">
            <img src="/assets/about/r.png" alt="">
          </div>
        </div>

        <div class="map-hover-box map-hover-box17 map-hover-box-right-top" v-if="mapHoverBoxs2 == 2">
          <div class="map-hover-text">
            <div class="map-hover-name">
              Thailand
            </div>
            <div class="map-hover-desc">
              Product: Engine.
            </div>
          </div>
          <div class="img-box">
            <img src="/assets/about/lt.png" alt="">
          </div>
        </div>

        <div class="map-hover-box map-hover-box18 map-hover-box-right-top" v-if="mapHoverBoxs2 == 2">
          <div class="map-hover-text">
            <div class="map-hover-name">
              Taizhou
            </div>
            <div class="map-hover-desc">
              Product: Supercharger、HCM/DCM.
            </div>
          </div>
          <div class="img-box">
            <img src="/assets/about/lt.png" alt="">
          </div>
        </div>

        <div class="map-hover-box map-hover-box19" v-if="mapHoverBoxs2 == 2">
          <div class="map-hover-text">
            <div class="map-hover-name">
              Pizhou
            </div>
            <div class="map-hover-desc">
              Product: Transmission、E-drive.
            </div>
          </div>
          <div class="img-box">
            <img src="/assets/about/r.png" alt="">
          </div>

        </div>
      </div>
    </div>

    <div class="about-management">
      <div class="img-box">
        <img class="pc-pad" data-src="/assets/about/management.jpg" alt="">
        <img class="mb-only" data-src="/assets/about/management-m.jpg" alt=""></img>
      </div>
      <div class="about-management-text">
        <div class="title">
          Compliance Management
        </div>
        <div class="text">
          Compliance is the cornerstone of an enterprise's sound development, as well as an inevitable requirement and
          fundamental guarantee for it to participate in global competition and achieve sustainable development.<br />
        </div>
        <div class="desc">
          In our global business operations, we consistently adhere to the philosophy of long-termism, bottom-line
          thinking, risk awareness, the spirit of contract, honesty and trustworthiness, and compliant operation.
          We require that all operational and management behaviors of the company and its employees comply with the
          provisions of laws and regulations, regulatory requirements, industry norms, the company's articles of
          association and internal rules,
          as well as the requirements of international treaties and universally accepted commercial practices worldwide.

        </div>
      </div>
    </div>
  </div>
  <Footer></Footer>
</template>

<script setup>
import { ref, onMounted, nextTick, onUnmounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import $ from 'jquery';
const swiperRefs = ref(null);
const swiperInstances = ref([]);

const hoverItemRefs = ref(1);

const mapHoverBoxs = ref(1);
const mapHoverBoxs2 = ref(1);

const initAllSwipers = async () => {
  await nextTick();
  const el = swiperRefs.value;
  if (el) {
    const swiper = new Swiper(el, {
      // loop: true,
      speed: 1300,
      pagination: {
        el: el.querySelector(".swiper-pagination"),
        clickable: true,
      },
      direction: "horizontal",
      simulateTouch: true,
      breakpoints: {
        768: {
        },
        1024: {
        }
      },
      on: {
        init: function () {
        },
        slideChangeTransitionStart(swiper) {
          let swiperIndex = swiper.realIndex;
        },
      },
    });
    swiperInstances.value.push(swiper);
  }
};
onMounted(() => {
  initAllSwipers()
  setTimeout(() => {
    $('.about-kv .text-box').addClass('active');
  }, 100);
})

</script>

<script>
export const pageConfig = {
  title: 'About FINEST - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
  outputPath: 'en/about.html'
};

import { createApp } from 'vue';
import App from './about.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"

function mountApp() {
  const appNode = document.getElementById('app');
  if (appNode) {
    if (appNode._vueApp) {
      appNode._vueApp.unmount();
      delete appNode._vueApp;
    }
    const app = createApp(App);
    app.use(store);
    appNode._vueApp = app.mount(appNode);
  }
}


// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
  module.hot.accept('./about.vue', () => {
    mountApp();
  });
}
</script>

<style lang="scss">
// .img-box-height{
//   min-height: 100vh;
// }
.about-kv {
  .img-box img {
    width: 100%;
    height: 100vh;
    object-fit: cover;
  }

  .text-box {
    position: absolute;
    z-index: 1;
    // left: 50%;
    // top: 2rem;
    left: 1.56rem;
    top: 3.51rem;
    color: #fff;
    width: 6rem;
    transform: translateY(2rem);
    opacity: 0;
    text-align: left;

    .title {
      font-size: 0.45rem;
      font-weight: 500;
      margin-bottom: 0.3rem;
    }

    .text {
      font-weight: 400;
      font-size: 0.17rem;
      line-height: 0.3rem;
    }

    &.active {
      transform: translateY(0);
      opacity: 1;
      transition: all 1s ease-in-out 0.5s;
    }
  }

}

.about-kv2 {
  .img-box img {
    width: 100%;
    height: 100vh;
    object-fit: cover;
  }

  .text-box {
    position: absolute;
    z-index: 1;
    left: 50%;
    top: 1.3rem;
    color: #fff;
    width: 8rem;
    transform: translateX(-50%) translateY(2rem);
    opacity: 0;
    // text-align: left;
    text-align: center;

    .title {
      font-size: 0.45rem;
      font-weight: 500;
      margin-bottom: 0.3rem;
    }

    .text {
      font-weight: 400;
      font-size: 0.17rem;
      line-height: 0.3rem;
    }

    &.active {
      transform: translateX(-50%) translateY(0);
      opacity: 1;
      transition: all 1s ease-in-out 0.5s;
    }
  }

}

.about-hover-list {
  display: flex;
  justify-content: space-between;
  width: 100%;

  .hover-item {
    position: relative;
    transition: all 0.5s;
    width: 25%;
    height: 9rem;

    .hover-img {
      width: 100%;
      height: 100%;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .hover-master {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      bottom: 0;
      transition: all 0.5s ease-in-out;
      z-index: 2;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      color: #fff;
      text-align: center;
      flex-direction: column;
      gap: 0.6rem;

      .hover-icon {
        width: 1.7rem;
      }

      .title {
        font-size: 0.5rem;
        font-weight: 600;
        margin-bottom: 0.13rem;
        position: relative;

        &::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: -0.3rem;
          width: 0;
          height: 0.01rem;
          background: #fff;
          transition: all 0.5s;
        }
      }

      .text {
        font-size: 0.28rem;
        font-weight: 300;
        line-height: 0.4rem;
        width: 80%;
        height: 0;
        overflow: hidden;
        transition: all 0.5s;
        white-space: nowrap;

      }

    }

    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 50%;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.9) 100%);
      transition: all 0.5s;
    }

    &.active {
      width: 50%;

      .hover-master {
        justify-content: center;

        .text {

          height: 1.5rem;
        }

        .title::after {
          width: 100%;
        }
      }

      &.active::after {
        height: 100%;
      }
    }
  }
}

.culture-list {
  display: flex;
  justify-content: space-between;
  position: absolute;
  bottom: 1rem;
  left: 0;
  color: #fff;
  width: 100%;


  .culture-item {
    width: 33%;
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    text-align: center;
    align-items: center;

    .culture-item-t1 {
      font-size: 0.4rem;
      font-weight: 500;
      width: 80%;
    }

    .culture-item-t2 {
      font-size: 0.17rem;
      font-weight: 300;
      line-height: 0.3rem;
      width: 80%;
      height: 0.9rem;
    }
  }
}

.about-map-box {
  position: relative;

  .about-map-item {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;

    .about-map-text {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 1.08rem;
      color: #000;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;


      .about-map-title {
        font-size: 0.5rem;
        font-weight: 500;
        margin-bottom: 0.3rem;
      }

      .about-map-desc {
        font-weight: 300;
        font-size: 0.2rem;
      }

      .about-map-btn-list {
        display: flex;
        gap: 0.11rem;
        justify-content: center;
        align-items: center;
        width: 3.3rem;
        height: 0.52rem;
        background: rgba($color: #002D4C, $alpha: 0.36);
        border-radius: 0.27rem;
        // margin-top: 0.3rem;
        color: #fff;

        .about-map-btn {
          width: 1.5rem;
          height: 0.39rem;
          background: rgba($color: #002D4C, $alpha: 0.37);
          border-radius: 0.2rem;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 0.13rem;
          font-weight: 400;
          cursor: pointer;

          &.active {
            background: linear-gradient(135deg, #E70012 0%, #EA5433 100%);
          }
        }
      }
    }

    .map-hover-box {
      position: absolute;
      color: #000000;
      width: 0;
      height: 0;
      border: #E70012 0.08rem solid;
      border-radius: 0.08rem;
      text-align: center;
      cursor: pointer;
      transition: all 0.5s;
      z-index: 2;

      &::after {
        content: '';
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 0.08rem;
        height: 0.08rem;
        border-radius: 0.08rem;
        background: rgba($color: #E70012, $alpha: 0.21);
        animation: scalePulse 2s linear infinite;
      }

      .map-hover-text {
        display: flex;
        justify-content: center;
        flex-direction: column;
        position: absolute;
        // left: 0.86rem;
        // top: 0.16rem;
        left: 1.2rem;
        top: 1.3rem;
        text-align: left;
        white-space: nowrap;
        gap: 0.28rem;
        width: 0;
        overflow: hidden;

        .map-hover-name {
          font-weight: 600;
        }
      }

      .img-box {
        width: 0;
        height: auto;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        transition: all 0.5s;
        overflow: hidden;

        img {
          width: 3.66rem;
          height: 1.68rem;
          position: absolute;
          left: 0;
          top: 0;
        }
      }

      &:hover {
        &::before {
          width: 1rem;
        }

        .map-hover-text {
          width: 3.5rem;
          transition: all 0.5s;
          transition-delay: 0.5s;
        }

        .img-box {
          width: 3.66rem;
          height: 1.68rem;
        }
      }

      &.map-hover-box-left {
        left: 60%;
        top: 50%;

        .map-hover-text {
          right: 1.3rem;
          left: auto;
          text-align: right;
        }

        .img-box {
          left: auto;
          right: 0;

          img {
            left: auto;
            top: auto;
            right: 0;
            bottom: 0;

          }
        }
      }

      &.map-hover-box-left-top {
        left: 60%;
        top: 50%;

        &::before {
          transform: rotate(-30deg);
        }

        .map-hover-text {
          left: 1.3rem;
          top: -2.1rem;
        }

        .img-box {
          left: 0;
          top: auto;
          bottom: 0;

          img {
            top: auto;
            bottom: 0;

          }
        }
      }

      &.map-hover-box-right-top {
        left: 60%;
        top: 50%;

        &::before {
          transform: rotate(-150deg);
        }

        .map-hover-text {
          right: 1.3rem;
          left: auto;
          top: -2.1rem;
          text-align: right;
        }

        .img-box {
          left: auto;
          top: auto;
          right: 0;
          bottom: 0;

          img {
            left: auto;
            top: auto;
            right: 0;
            bottom: 0;

          }
        }
      }

      &.map-hover-box1 {
        left: 38%;
        top: 52.5%;

        &:hover {

          .map-hover-text {
            width: 8rem;
          }
        }
      }

      &.map-hover-box2 {
        left: 38.8%;
        top: 55%;
      }

      &.map-hover-box3 {
        left: 40%;
        top: 57.5%;

        &:hover {

          .map-hover-text {
            width: 8rem;
          }
        }
      }

      &.map-hover-box4 {
        left: 39%;
        top: 57%;

        &:hover {

          .map-hover-text {
            width: 8rem;
          }
        }
      }

      &.map-hover-box5 {
        left: 38%;
        top: 58%;

      }

      &.map-hover-box6 {
        left: 35%;
        top: 58%;
      }

      &.map-hover-box7 {
        left: 37.8%;
        top: 61%;

        &:hover {

          .map-hover-text {
            width: 8rem;
          }
        }
      }

      &.map-hover-box8 {
        left: 38%;
        top: 52.5%;
        border: #E70012 0.05rem solid;

        &:hover {

          .map-hover-text {
            width: 8rem;
          }
        }
      }

      &.map-hover-box9 {
        left: 40%;
        top: 56.5%;
        border: #E70012 0.05rem solid;

        &:hover {

          .map-hover-text {
            width: 8rem;
          }
        }
      }

      &.map-hover-box10 {
        left: 39%;
        top: 52.5%;
        border: #E70012 0.05rem solid;
      }

      &.map-hover-box11 {
        left: 40.2%;
        top: 57.9%;
        border: #E70012 0.05rem solid;

        &:hover {

          .map-hover-text {
            width: 8rem;
          }
        }
      }

      &.map-hover-box12 {
        left: 39.2%;
        top: 56.5%;
        border: #E70012 0.05rem solid;

        &:hover {

          .map-hover-text {
            width: 8rem;
          }
        }
      }

      &.map-hover-box20 {
        left: 38%;
        top: 58%;
        border: #E70012 0.05rem solid;

        &:hover {

          .map-hover-text {
            width: 8rem;
          }
        }
      }

      &.map-hover-box13 {
        left: 39.8%;
        top: 58.5%;
        border: #E70012 0.05rem solid;

        &:hover {

          .map-hover-text {
            width: 8rem;
          }
        }
      }

      &.map-hover-box14 {
        left: 25%;
        top: 39%;
        border: #E70012 0.05rem solid;

        .map-hover-text {
          display: none;
        }

        &::before {
          display: none;
        }
      }

      &.map-hover-box15 {
        left: 36%;
        top: 59.5%;
        border: #E70012 0.05rem solid;

        &:hover {

          .map-hover-text {
            width: 8rem;
          }
        }
      }

      &.map-hover-box16 {
        left: 38.5%;
        top: 60%;
        border: #E70012 0.05rem solid;
      }

      &.map-hover-box17 {
        left: 34.5%;
        top: 65.5%;
        border: #E70012 0.05rem solid;
      }

      &.map-hover-box18 {
        left: 39.5%;
        top: 55.5%;
        border: #E70012 0.05rem solid;

        &:hover {

          .map-hover-text {
            width: 8rem;
          }
        }
      }

      &.map-hover-box19 {
        left: 39%;
        top: 54%;
        border: #E70012 0.05rem solid;

        &:hover {

          .map-hover-text {
            width: 8rem;
          }
        }
      }

    }
  }
}

.about-management {
  position: relative;

  .about-management-text {
    position: absolute;
    left: 1.56rem;
    top: 50%;
    transform: translateY(-50%);
    color: #000;
    width: 7.3rem;

    .title {
      font-size: 0.5rem;
      font-weight: 500;
      margin-bottom: 0.3rem;
    }

    .text {
      font-weight: 400;
      font-size: 0.2rem;
      margin-bottom: 0.57rem;
      line-height: 0.3rem;
      // color: #676767;


    }

    .desc {
      font-size: 0.16rem;
      font-weight: 300;
      line-height: 0.28rem;
      // color: #676767;
    }
  }
}



@keyframes scalePulse {
  0% {
    width: 0.08rem;
    height: 0.08rem;
    border-radius: 0.08rem;
    opacity: 1;
  }

  100% {
    width: 0.32rem;
    height: 0.32rem;
    border-radius: 0.32rem;
  }
}

@media (max-width: 768px) {
  .about-kv2 {
    .text-box {
      top: 2.26rem;
      width: 6.5rem;
      display: flex;
      flex-direction: column;
      align-items: center;

      .title {
        font-size: 0.5rem;
      }

      .text {
        font-size: 0.22rem;
        width: 90%;
      }
    }
  }

  .culture-list {
    flex-direction: column;
    bottom: auto;
    top: 2.24rem;
    align-items: center;
    gap: 0.92rem;

    .culture-item {
      width: 5.45rem;

      .culture-item-t1 {
        font-size: 0.42rem;
      }

      .culture-item-t2 {
        font-size: 0.23rem;
        height: auto;

      }
    }
  }

  .about-map-box {
    .about-map-item {
      .about-map-text {
        top: 1.5rem;
        width: 100%;

        .about-map-btn-list {
          width: 3.85rem;
          height: 0.68rem;

          .about-map-btn {
            width: 1.71rem;
            height: 0.52rem;
            border-radius: 0.26rem;
            font-size: 0.17rem;
          }
        }
      }

      .map-hover-box {
        display: none;
      }
    }
  }

  .about-management {
    .about-management-text {
      left: 50%;
      top: 1.5rem;
      transform: translateX(-50%);
      width: 5.66rem;
      text-align: center;

      .title {
        font-size: 0.5rem;
      }

      .text {
        font-size: 0.22rem;
      }
    }
  }
}
</style>